module.exports = __webpack_public_path__ + "static/media/1009977.00ce1b12.jpg";